import { type CwcUserBetAmountData, cwcPackBetRewardStages } from '@nf/types/promotion';
import { useReward } from '@/contexts/reward-context';

export const BeginnersPackProgress = ({ betAmountData }: { betAmountData: CwcUserBetAmountData }) => {
	const { labels } = useReward();
	const currentStage = cwcPackBetRewardStages[betAmountData.Stage];
	const lastStage = cwcPackBetRewardStages[cwcPackBetRewardStages.length - 1];
	const isStageCompleted = betAmountData.Stage === lastStage.stage;
	const currentPercentage = isStageCompleted 
		? 100 
		: (((betAmountData.Amount - currentStage.threshold) / (cwcPackBetRewardStages[betAmountData.Stage + 1].threshold - currentStage.threshold)) * (1 / (cwcPackBetRewardStages.length - 1)) + 
			betAmountData.Stage * (1 / (cwcPackBetRewardStages.length - 1))) * 100;

	const getStageTitle = (threshold: number) => {
		return threshold === 0 
			? labels?.lbl_IDRRFProgress07 
			: `${threshold} IDR`;
	};

	return (
		<div className="my-voucher-progress">
			<div className="my-voucher-progress__divider"></div>
			<div className="my-voucher-progress__title">
				{labels?.lbl_IDRRFProgress01}
			</div>

			<div className="beginners-pack-progress">
				<div className="beginners-pack-progress__header">
					{/* Show total bet amount value if not all stages are completed */}
					{isStageCompleted 
						? labels?.lbl_IDRRFProgress03
						: labels?.lbl_IDRRFProgress02?.replace('{x}', String(betAmountData.Amount))
					}
				</div>
				<div className="beginners-pack-progress__container">
					<div className="beginners-pack-progress__bar">
						<div 
							className="beginners-pack-progress__bar-inner" 
							style={{ width: `${currentPercentage}%` }}
						>
						</div>
					</div>

					{cwcPackBetRewardStages.map(rewardStage => (
						<div
							key={rewardStage.stage}
							className="beginners-pack-progress__item"
							data-enabled={rewardStage.stage <= betAmountData.Stage}
							data-active={rewardStage.stage === betAmountData.Stage}
						>
							<div className="beginners-pack-progress__gift">
								<div className="beginners-pack-progress__point">20 IDR</div>
							</div>
							<div className="beginners-pack-progress__label">
								{getStageTitle(rewardStage.threshold)}
							</div>
						</div>
					))}
				</div>
			</div>
			<div className="beginners-pack-progress-msg">
				{labels?.lbl_IDRRFProgress04}
			</div>
		</div>
	);
};